import { AskConsumerLayout } from "@ui/layouts/AskConsumerLayout/AskConsumerLayout";
import { VStack } from "@ui/Stack";
import { createSignal } from "solid-js";
import { AllCategories } from "./components/AllCategories";
import { CategoryGrid } from "./components/CategoryGrid";
import { DiscoveryNewQuestionCard } from "./components/DiscoveryNewQuestionCard";
import { SuggestedCreators } from "./components/SuggestedCreators";

export const DiscoveryApp = () => {
	const [allOpen, setAllOpen] = createSignal(false);

	return (
		<AskConsumerLayout title="Discovery" signedOutTopNav>
			<div class="askgvt-page">
				<VStack spacing="large">
					<DiscoveryNewQuestionCard />
					<CategoryGrid onAll={() => setAllOpen(true)} />
					<SuggestedCreators />
				</VStack>
			</div>
			<AllCategories open={allOpen} onClose={() => setAllOpen(false)} />
		</AskConsumerLayout>
	);
};
